import { RealityCheck } from '../responsible/RealityCheck';
import { GameErrorHost } from './GameErrorHost';

/** K9 overlays mounted once in the app chrome: designed game errors + reality check reminder. */
export function GlobalHosts() {
  return (
    <>
      <GameErrorHost />
      <RealityCheck />
    </>
  );
}
